import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { StepNumber } from '@/components/frontend/atoms/content/StepNumber'
import { Badge } from '@/components/frontend/atoms/content/Badge'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'

interface StepItemProps {
  number: number
  meta: string
  title: string
  description: string
}

export const StepItem: React.FC<StepItemProps> = ({ number, meta, title, description }) => (
  <Stack gap="4">
    <Inline gap="3" justify="between">
      <StepNumber number={number} />
      <Badge>{meta}</Badge>
    </Inline>
    <Stack gap="2">
      <Heading level="4" as="h3">{title}</Heading>
      <Text size="sm" tone="muted">{description}</Text>
    </Stack>
  </Stack>
)
